import { useEffect, useState } from 'react';

export default function XPProgressBar({ level, xp, xpForNextLevel }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setProgress((xp / xpForNextLevel) * 100);
    }, 100);
  }, [xp, xpForNextLevel]);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg hover-lift animate-scale-in">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="text-4xl font-bold text-purple-600">Lv.{level}</div>
          <div>
            <p className="text-sm text-gray-600">Seviye {level}</p>
            <p className="text-xs text-gray-500">{xp} / {xpForNextLevel} XP</p>
          </div>
        </div>
        <div className="text-4xl animate-pulse-slow">⚡</div>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-purple-500 to-pink-500 rounded-full progress-bar transition-all duration-500"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}